import { render, staticRenderFns } from "./todayIntergral.vue?vue&type=template&id=983f5a9c&scoped=true&"
import script from "./todayIntergral.vue?vue&type=script&lang=js&"
export * from "./todayIntergral.vue?vue&type=script&lang=js&"
import style0 from "./todayIntergral.vue?vue&type=style&index=0&id=983f5a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983f5a9c",
  null
  
)

export default component.exports